module.exports = __webpack_public_path__ + "img/media-yt.a0fdbd6d.png";